export const theme = {
  bgColors: {
    green: `#9bf08c`,
    yellow: `#f0d98c`,
    red: `#f08c8c`,
    gray: `#e5e5e5`,
  },

  borderColors: {
    hasBattle: `red`,
    hasNoBattle: `green`,
    inactive: `#a7a7a7`,
  }
}